const buildTarget = 'production'; // staging/production

let env = 'development';
if (process.env.NODE_ENV !== 'development') {
  env = buildTarget;
}

export default env;
